<template>
  <div>
      <div class="wj-manage">
        <el-header
          class="wj-header flex space-between"
          style="width: 100%; position: fixed; z-index: 999"
        >
          <el-menu class="back" mode="horizontal">
            <el-menu-item @click="myExam()" class="menu-header-text"
              ><i class="el-icon-arrow-left"></i> 我的考试</el-menu-item
            >
          </el-menu>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
          >
            <!-- <el-menu-item index="0" class="menu-header-text">
              <router-link to="" tag="li">首页</router-link>
            </el-menu-item> -->
            <el-menu-item index="1" class="menu-header-text">
              <li @click="toCreateExam">考试设计</li>
              <!-- <router-link :to="{ name: 'CreateExam' }" tag="li">考试设计</router-link> -->
            </el-menu-item>
            <el-menu-item index="2" class="menu-header-text">
              <router-link :to="{ name: 'SendTest' }" tag="li">发送考卷</router-link>
            </el-menu-item>
            <el-menu-item index="3" class="menu-header-text">
              <router-link :to="{ name: 'ExamStats' }" tag="li">成绩&数据</router-link>
            </el-menu-item>
          </el-menu>
          <div class="preview">
            <p class="btn" @click="toPreview">预览</p>
          </div>
        </el-header>
        <router-view ref="sonMethod"></router-view>
      </div>
  </div>
  
</template>


<script>
import qs from 'qs'
export default {
  name: "ExamManageTop",
  data() {
    return {
    };
  },
  computed: {
    activeIndex: {
      get() {
        switch (this.$route.name) {
          case "CreateExam":
          case 'ExamAppearance':
          case 'ExamSetting':
            return "1";
          case "ResultStats":
          case "RankingList":
            return "3";
          case "SendTest":
            return "2";
          default:
            return "0";
        }
      },
      set(v) {
        return v
      }
      
    },
    id: {
      get() {
        return sessionStorage.getItem('examId') || ''
      },
      set() {
      }
    }
  },
  mounted() {
    this.type = this.$route.query.type || 0;
    // console.log(this.wid)
  },
  watch: {},
  methods: {
    toCreateExam() {
      this.id = sessionStorage.getItem("examId")
      if (sessionStorage.getItem("state") == 2) {
        this.$confirm(`在您修改考试时，考试会暂停收集，影响已收集的数据，您需要在修改完后再次发布考试才可继续进行收集。`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
            let data = qs.stringify({
              'id': this.id,
              'state': 1
            })
            let that = this
            let params = {
              that: this,
              url: `${this.$config.service.examProjectEditState}?${data}`,
              method: "POST",
              cb(res) {
                if(res.code == '0') {
                  sessionStorage.setItem("state", 1)
                  setTimeout(() => {
                    that.$router.push({ path: "/createExam" });
                  }, 400);
                }
              },
            };
            this.$util.request(params)
          }).catch(() => {     
            this.activeIndex = '2'
        });
      } else {
        this.$router.push({ path: "/createExam" });
      }
      // console.log()
    },
    toPreview() {
      this.$router.push({
        path: '/examPreview',
        query: {
          id: this.id
        }
      })
    },
  //   getData(data) {
  //     let that = this
  //     let params = {
  //         that: this,
  //         url: `${this.$config.service.examUnderwayClickAnswer}`,
  //         method: "POST",
  //         data: {
  //           surveyId: this.id
  //         },
  //         cb(res) {
  //         console.log(res)
  //         that.code = res.code
  //         that.message = res.message
  //         switch (res.code) {
  //             case '2001': // 密码型
  //                 that.showPassword = true
  //                 if(state == 1) {
  //                     that.$message.error('请输入密码')
  //                     that.passwordError = true
  //                     that.passwordErrorTip = res.message
  //                 }
  //                 break;
  //             case '2000': // 密码错误
  //                 that.passwordError = true
  //                 that.passwordErrorTip = res.message
  //                 break;
  //             case '1001': // 考试已结束
  //                 that.$message.error(res.message)
  //                 break;
  //             case '2002': // 考试未开始
  //                 that.isStartTime = false
  //                 that.examStartTime = res.resultBody.examStartTime
  //                 that.$message.error(res.message)
  //                 break;
  //             case '0':
  //                 that.data = JSON.parse(res.resultBody.papersStyle)
  //                 that.list = that.data.questionsList
  //                 that.examData = res.resultBody
  //                 console.log(that.data)
  //                 console.log(that.list)
  //         }
  //         },
  //     };
  //     this.$util.request(params)
  // },
    myExam() {
      this.id = sessionStorage.getItem("examId");
      this.$router.push("/MyExam");
    },
  },
  beforeDestroy() {
    // sessionStorage.removeItem("examId")
  },
};
</script>

<style lang="scss" scoped>
.wj-manage {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
  .wj-header {
    background-color: #fff;

    .menu-header-text {
      font-size: 18px;
			display: flex;
			align-items: baseline;
    }
  }
}

.el-input__inner {
  padding: 0px !important;
}
.preview{
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #909399;
  display: flex;
  .btn+.btn{
    margin-left: 30px;
  }
  .btn{
    padding: 0 20px;
    cursor: pointer;
    box-sizing: border-box;
  }
}
</style>
